import {colorN, ColorPaletteOption, getColorPalette} from '../../util/colors';
import type {ArtifactVersionMetricChartRow} from './types';

const DEFAULT_SERIES_PALETTE = getColorPalette(ColorPaletteOption.DEFAULT);

/** Stable color slot from version identity, not table selection order. */
export function getArtifactVersionMetricColorIndex(
  row: Pick<
    ArtifactVersionMetricChartRow,
    'label' | 'selectionIndex' | 'versionIndex'
  >
): number {
  if (row.versionIndex != null && Number.isFinite(row.versionIndex)) {
    return row.versionIndex;
  }

  const versionMatch = /^v(\d+)$/i.exec(row.label.trim());
  if (versionMatch != null) {
    return Number.parseInt(versionMatch[1], 10);
  }

  return row.selectionIndex;
}

export function getArtifactVersionMetricColor(
  row: Pick<
    ArtifactVersionMetricChartRow,
    'label' | 'selectionIndex' | 'versionIndex'
  >
): string {
  return colorN(
    getArtifactVersionMetricColorIndex(row),
    DEFAULT_SERIES_PALETTE
  );
}

export function getArtifactVersionMetricColorRange(
  rows: ArtifactVersionMetricChartRow[]
): string[] {
  return rows.map(row => getArtifactVersionMetricColor(row));
}
